<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="room !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.room.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>


    <div class="p-grid p-fluid">

      <div class="p-col-12">
        <app-form-control [cid]="'active'" [control]="form.get('active')" [type]="'checkbox'" [label]="t('common.labels.active')" [edit]="inEdit" [basevalue]="room.active"></app-form-control>
      </div>

      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="room.name"></app-form-control>
        <app-form-control [cid]="'type'" [control]="form.get('type')" [type]="'select'" [options]="types" [label]="t('common.labels.type')" [edit]="inEdit" [basevalue]="transloco.translate(roomTypes[room.type])"></app-form-control>
        <app-form-control [cid]="'capacity'" [control]="form.get('capacity')" [type]="'input'" [label]="t('common.labels.capacity')" [edit]="inEdit" [basevalue]="room.capacity"></app-form-control>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'location'" [control]="form.get('location')" [type]="'select'" [options]="locations" optionLabel="name" [label]="t('common.labels.location')" [edit]="inEdit" [basevalue]="room.location?.name"></app-form-control>
        <app-form-control [cid]="'zip'" [control]="form.get('zip')" [type]="'input'" [label]="t('common.labels.zip')" [edit]="inEdit" [basevalue]="room.zip"></app-form-control>
        <app-form-control [cid]="'street'" [control]="form.get('street')" [type]="'input'" [label]="t('common.labels.street')" [edit]="inEdit" [basevalue]="room.street"></app-form-control>
        <app-form-control [cid]="'addition'" [control]="form.get('addition')" [type]="'input'" [label]="t('common.labels.addition')" [edit]="inEdit" [basevalue]="room.addition"></app-form-control>
      </div>

      <div class="p-col-12">
          <h2>{{ t('common.labels.contacts') }}</h2>
      </div>

      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'mail_registration'" [control]="form.get('mail_registration')" [type]="'input'" [label]="t('rooms.labels.mail_registration')" [edit]="inEdit" [basevalue]="room.mail_registration"></app-form-control>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'mail_catering'" [control]="form.get('mail_catering')" [type]="'input'" [label]="t('rooms.labels.mail_catering')" [edit]="inEdit" [basevalue]="room.mail_catering"></app-form-control>
      </div>

    </div>

  </form>
</ng-container>
